export default "__VITE_ASSET__ERdIvIsN__"